<template>
  <div class="about-company __box-wrap">
    <div class="__layout-wrap">
      <ul class="__layout-tab">
        <li
          v-for="(vo,idx) in tab"
          :key="vo"
          :class="{ 'on': idx == act }"
          @click="toggleTab(vo,idx)"
        >{{ vo }}
        </li>
      </ul>
      <div class="__layout-container">
        <div class="__layout-headline">{{ headline }}</div>
        <div class="__layout-content">

          <!-- 关于我们 -->
          <div
            v-if="act == 0"
            class="about">
            <p class="p3"><span class="s2">潮国创意隶属于上海图魂网络科技有限公司，成立于</span><span class="s3">2022</span><span class="s2">年</span><span class="s3">3</span><span class="s2">月，主要为国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源。</span></p>
            <p class="p3"><span class="s2">我们聚焦商业设计在多场景多领域的使用，为此而提供高质量在线商用授权设计资源。国内最潮前沿内容就在潮国创意。</span></p>
            <!-- <p class="p4"><span class="s4">联系我们：</span><span class="s2">021-61515010  9:30-18:30</span><span class="s4">（工作日）</span></p> -->
            <p class="p3"><span class="s2">地址：上海市浦东新区碧波路</span><span class="s3">690</span><span class="s2">号张江微电子港</span><span class="s3">1</span><span class="s2">号楼</span><span class="s3">302</span></p>

            <h3>网站简介</h3>
            <p class="p3">潮国创意，拥有高品质内容，精品3D、电商设计、平面设计、UI设计，每日更新精品潮流设计，正版可商用设计网站平台。围绕独特，稀缺，高端，前沿，</p>
            <p class="p3">设计最大胆的品牌营销素材站。旨在成为脱离传统单一刻板的素材网站，新设计趋势的创造者。</p>

            <h3>网站内容</h3>
            <p class="p3">精品3D库：3D海报，3D人像，3D场景，3D元素</p>
            <p class="p3">电商设计：电商首页，电商海报，banner，电商主图，活动页/详情页</p>
            <p class="p3">节日节气：24节气，节日营销方案</p>
            <p class="p3">通用热点：行业日常营销类设计</p>

            <h3>网站特色</h3>
            <p class="p3">3D内容质量高，使用范围广，功能性强，实用性高，更适合设计师群体使用。</p>
            <p class="p3">会员需求池：成为VIP可以提需求，满足大部分会员的需求，宠粉行为为用户提供定制化服务。</p>
            <p class="p3">以会员为出发点的运营性网站，会员有归属感、荣耀感、依赖感，和普通素材网站有本质上的运营体系的区别。</p>

          </div>

          <!-- 版权声明 -->
          <div
            v-if="act == 1"
            class="copyright">
            <p class="p3"><span class="s3">1</span><span class="s2">、潮国创意（</span><span class="s3">chaopx.com</span><span class="s2">）为上海图魂网络科技有限公司所有并运营。潮国创意中所展示、传播的任何图片、图形、音频、字体、文本等设计素材及视频资料中所涉及的著作权、专利权、商标权、商业秘密等知识产权及其它信息内容均受版权、商标等现行相关法律保护，潮国创意就网站中所展示、传播的作品享有著作权或已获相关授权，但相关页面另有标注的除外。除本协议另有约定外，未经相关权利人同意，任何人不得使用、展示、传播潮国创意作品，不得将上述作品用于任何商业</span><span class="s3">/</span><span class="s2">非商业目的。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">2</span><span class="s2">、未经潮国创意许可，用户不得将潮国创意作品进行修改、改编、汇编，不得依据潮国创意作品进行二次创作，不得就相关作品进行表演、录制、发行。用户需确保潮国创意所提供的内容符合其使用需求，潮国创意就相关作品、资料与用户需求的使用契合度不作任何保证。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">3</span><span class="s2">、潮国创意为提供作品整体的艺术美感、使用价值而展示的任何软件的一切权利均属于该软件著作权人，未经权利人许可，用户不得对该软件进行使用、反汇编、反向编译、反向工程。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">4</span><span class="s2">、潮国创意鼓励用户对网站上的作品进行全面监督，潮国创意已通过用户协议等其它文件明确告知作者不得侵犯他人合法权益，潮国创意已设置专业岗位及专业审核人员就潮国创意所展示的作品进行定期</span><span class="s3">/</span><span class="s2">不定期审查，但因潮国创意图库庞大，潮国创意审核人员无法一一排除所有存在权属瑕疵作品。如依据《中华人民共和国著作权法》、《信息网络传播权保护条例》、《中华人民共和国民法典》（侵权责任编）及现行法律法规，您发现潮国创意存在侵犯您或任意第三方知识产权之行为，您可通过采取联系潮国创意客服或向潮国创意发送侵权通知等措施及时通知潮国创意进行下架，潮国创意将在收到您的侵权通知后合理期限内予以核实，如您所述情况属实，潮国创意将及时删除相关作品避免造成您的损失；但您已知悉，如相关行为人通过发送反通知方式向潮国创意提交相关材料的，潮国创意可恢复相关作品的展示、传播，由此产生的纠纷由您与上传者自行解决。您所提交的通知中应包含如下材料：</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s2">（</span><span class="s3">1</span><span class="s2">）个人身份证件</span><span class="s3">/</span><span class="s2">公司营业执照复印件（签字</span><span class="s3">/</span><span class="s2">加盖公章）；</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s2">（</span><span class="s3">2</span><span class="s2">）联系地址及联系方式；</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s2">（</span><span class="s3">3</span><span class="s2">）您所需删除的相关作品链接、名称及相关信息；</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s2">（</span><span class="s3">4</span><span class="s2">）可初步证明您为权利人的相关权属材料（包括但不限于首次发表记录、版权登记证书、作品源文件等）。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">5</span><span class="s2">、未经潮国创意许可，任何人不得通过爬虫程序、脚本、机器人程序等窃取潮国创意所展示、传播的作品，不得故意绕开潮国创意所设置的网络障碍侵犯潮国创意合法权益；不得复制、仿造潮国创意网站实施侵权行为。不得就潮国创意的源代码、网站技术措施进行反汇编、反向编译、反向工程等。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">6</span><span class="s2">、潮国创意用户均应于合理范围内使用潮国创意作品，因用户违约使用或超出相应授权范围使用相关作品所产生的一切不利后果均由用户自行承担，潮国创意不因此承担任何责任。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s3">7</span><span class="s2">、请您确保您已充分理解并同意本文档中相关表述，如您不接受本声明中部分或全部条款的，请您立即停止使用潮国创意服务，您注册潮国创意账号，使用潮国创意服务的行为视为您已知悉并同意遵守潮国创意相关条款。</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <p class="p3"><span class="s2">版权投诉举报通道</span><span class="s3"><span class="Apple-converted-space"> </span></span></p>
            <!-- <p class="p4"><span class="s4">电话：</span><span class="s2">02161515010 </span><span class="s4">（周一至周五</span><span class="s2"> 9:30—18:00</span><span class="s4">）</span><span class="s2"><span class="Apple-converted-space"> </span></span></p> -->
            <p class="p4"><span class="s4">邮箱：</span><span class="s2">248172239@qq.com<span class="Apple-converted-space"> </span></span></p>
          </div>

          <!-- 联系我们 -->
          <div
            v-if="act == 2"
            class="contact">
            <p class="p3"><span class="s2">潮国创意隶属于上海图魂网络科技有限公司，成立于</span><span class="s3">2022</span><span class="s2">年</span><span class="s3">3</span><span class="s2">月，主要为国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源。</span></p>
            <p class="p3"><span class="s2">我们聚焦商业设计在多场景多领域的使用，为此而提供高质量在线商用授权设计资源。国内最潮前沿内容就在潮国创意。</span></p>
            <!-- <p class="p4"><span class="s4">联系我们：</span><span class="s2">021-61515010  9:30-18:30</span><span class="s4">（工作日）</span></p> -->
            <p class="p3"><span class="s2">地址：上海市浦东新区碧波路</span><span class="s3">690</span><span class="s2">号张江微电子港</span><span class="s3">1</span><span class="s2">号楼</span><span class="s3">302</span></p>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexExtend from "../common/protocol-extend";

export default {
  name: "AboutCompany",
  mixins: [indexExtend],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    act: 0
  },
  data() {
    return {

      tab: [
        "关于我们",
        "版权声明",
        "联系我们",
      ]
    }
  },
  mounted() {
    this.headline = this.tab[this.act];
  }

}
</script>

<style lang="scss" scoped>
@import "pages/protocol/common/common";


.about{
  h3{
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}


</style>
